<template>
  <div class="page-content ride-ordering">
    <div class="row">
      <div
        class="col-sm-6 col-12"
      >
        <h2>Multi-Vendor Ride Ordering</h2>

        <el-radio-group v-model="rideFormType">
          <el-radio-button label="order">
            Order a Ride Now
          </el-radio-button>
          <el-radio-button
            label="schedule"
            :disabled="isNashDeliverySelected"
          >
            Schedule a Ride in the Future
            <br/>
            <small v-if="isNashDeliverySelected">Only available for transportation</small>
          </el-radio-button>
        </el-radio-group>

        <basic-ride-limit-value-upgrade-banner class="mt-3 mb-3" />

        <template v-if="rideFormType === 'order'">
          <OrderRides
            @change-ride-form="rideFormType = 'schedule'"
            @update:isNashDelivery="isNashDeliverySelected = $event"
          />
          <emergency-ride-request />
        </template>
        <ride-scheduler v-if="rideFormType === 'schedule'" />
      </div>
      <div class="col-sm-6 col-12">
        <cancel-ride />
        <cancel-auto-retry-ride />
        <template v-if="!isPartnerDashboard">
          <uber-ride-destination />
          <rescan-ride />
          <text-driver />
          <text-customer />
          <driver-arriving-call />
          <send-driver-details />
          <pharmacy-driver-arriving-call />
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, nextTick, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';
import { useDashboard } from '@/use/app';

import BasicRideLimitValueUpgradeBanner from './RideOrdering/BasicRideLimitValueUpgradeBanner.vue';
import OrderRides from './RideOrdering/OrderRides.vue';
import DriverArrivingCall from './RideOrdering/DriverArrivingCall.vue';
import SendDriverDetails from './RideOrdering/SendDriverDetails.vue';
import CancelRide from './RideOrdering/CancelRide.vue';
import CancelAutoRetryRide from './RideOrdering/CancelAutoRetryRide.vue';
import TextDriver from './RideOrdering/TextDriver.vue';
import RescanRide from './RideOrdering/RescanRide.vue';
import UberRideDestination from './RideOrdering/UberRideDestination.vue';
import PharmacyDriverArrivingCall from './RideOrdering/PharmacyDriverArrivingCall.vue';
import RideScheduler from './ScheduleRide/RideScheduler.vue';
import TextCustomer from './RideOrdering/TextCustomer.vue';
import EmergencyRideRequest from './RideOrdering/EmergencyRideRequest.vue';

export default {
  name: 'RideOrdering',

  components: {
    BasicRideLimitValueUpgradeBanner,
    OrderRides,
    TextDriver,
    DriverArrivingCall,
    CancelRide,
    CancelAutoRetryRide,
    SendDriverDetails,
    RescanRide,
    UberRideDestination,
    PharmacyDriverArrivingCall,
    RideScheduler,
    TextCustomer,
    EmergencyRideRequest,
  },

  setup: () => {
    const route = useRoute();

    const { isPartnerDashboard } = useDashboard();

    const rideFormType = ref('');
    const isNashDeliverySelected = ref(false);

    onMounted(async () => {
      const hash = route.hash;

      await nextTick();
      util.moveScrollComponent(hash);

      rideFormType.value = (route.query.rideFormType as string) || 'order';
    });

    return {
      isPartnerDashboard,
      rideFormType,
      isNashDeliverySelected,
    };
  },
};
</script>

<style lang="scss">
.ride-ordering {
  .el-radio-group {
    display: flex;
    align-items: unset;

    .el-radio-button {
      flex: 1;

      .el-radio-button__inner {
        width: 100%;
        height: 100%;

        justify-content: center;
        display: flex;
        flex-direction: column;
      }
    }
  }
}
</style>
